// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { Route, Routes } from "react-router-dom";

import { NotFound } from "~@jii/common-ui";
import { EGT, ProgramCatalog, UsCoMoreInformation } from "~@jii/paths";

import { PageMoreInformation } from "../pages/PageMoreInformation";
import { PageUsCoAllMonthsCreditReport } from "../pages/PageUsCoAllMonthsCreditReport";
import { PageUsCoMonthlyReport } from "../pages/PageUsCoMonthlyReport";
import { UsCoSingleResidentHome } from "../pages/UsCoSingleResidentHome";
import { UsCoProgramsList } from "./UsCoProgramsList/UsCoProgramsList";

export function UsCoRouter() {
  return (
    <Routes>
      <Route index element={<UsCoSingleResidentHome />} />
      <Route path={ProgramCatalog.path} element={<UsCoProgramsList />} />
      <Route
        path={EGT.AllMonths.path}
        element={<PageUsCoAllMonthsCreditReport />}
      />
      <Route
        path={EGT.MonthlyReport.path}
        element={<PageUsCoMonthlyReport />}
      />
      <Route path={UsCoMoreInformation.path}>
        <Route
          path={UsCoMoreInformation.EarnedTime.path}
          element={<PageMoreInformation pageSlug="earnedTime" />}
        />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
